<template>
  <div class="container sv sv003">
    <BreadcrumbGroup :items="breadcrumbItems" />

    <HeadingOne>知っておきたい！ローンについて</HeadingOne>

    <p class="_mb-md-50">
      ローン初心者向けの「ローンの基礎知識」や、みんなのローン活用術など、日々の暮らしをちょっとよくするコンテンツを配信しています。
    </p>

    <NoticeBox class="-cancel _mb-md-70">
      <ul class="list-box -textleft">
        <li class="list _mr-md-20 _mb-sm-10">
          <router-link
            v-scroll-to="{ el: '#section_01', offset: -90 }"
            :to="{ path: '#' }"
          >
            <IconBox src="arrow-down-orange" class="-xs _mr-md-10 _mr-sm-5">
            </IconBox>
            いまさら聞けない！ローンの基礎知識</router-link
          >
        </li>
        <li class="list _mr-md-20 _mb-sm-10">
          <router-link
            v-scroll-to="{ el: '#section_02', offset: -90 }"
            :to="{ path: '#' }"
            ><IconBox src="arrow-down-orange" class="-xs _mr-md-10 _mr-sm-5">
            </IconBox>
            教えて！みんなのローン活用術</router-link
          >
        </li>
        <li class="list">
          <router-link
            v-scroll-to="{ el: '#section_03', offset: -90 }"
            :to="{ path: '#' }"
          >
            <IconBox src="arrow-down-orange" class="-xs _mr-md-10 _mr-sm-5">
            </IconBox>
            auサービスでもっとおトクに</router-link
          >
        </li>
      </ul>
    </NoticeBox>

    <section id="section_01" name="section_01">
      <HeadingTwo class="-border-green _mb-sm-40 _mb-md-60">
        いまさら聞けない！ローンの基礎知識
      </HeadingTwo>

      <CardGroups class="-image-top-list">
        <CardBox router-name="sv009" class="-image-top">
          <CardHeader>
            <CardImage class="-green">
              <img
                src="@/assets/images/sv/sv009/thumb.jpg"
                class="img-fluid"
                alt=""
              />
            </CardImage>
            <h3 class="heading">ローンにおける金利の仕組みとは？</h3>
          </CardHeader>
          <CardBody
            >「金利・利息・実質年率ってなんだろう？」いまさら聞けないローンのキホンについて！</CardBody
          >
        </CardBox>
        <CardBox router-name="sv010" class="-image-top">
          <CardHeader>
            <CardImage class="-green">
              <img
                src="@/assets/images/sv/sv010/thumb.jpg"
                class="img-fluid"
                alt=""
              />
            </CardImage>
            <h3 class="heading">ローンの返済方法やルールとは？</h3>
          </CardHeader>
          <CardBody
            >「お金を借りたらどうやって返すの…？」au PAY
            スマートローンの返済方法についてはこちら。</CardBody
          >
        </CardBox>
        <CardBox router-name="sv011" class="-image-top">
          <CardHeader>
            <CardImage class="-green">
              <img
                src="@/assets/images/sv/sv011/thumb.jpg"
                class="img-fluid"
                alt=""
              />
            </CardImage>
            <h3 class="heading">ローンって借りすぎないかな？</h3>
          </CardHeader>
          <CardBody>
            借り入れできる金額には制限があるんです！「いつのまにか借りすぎてしまうことってないかな…？」と気になる方はこちら。
          </CardBody>
        </CardBox>
      </CardGroups>

      <BtngroupSingle class="-margin-lg">
        <BtnMain class="-normal -lg" router-name="sv043">
          いまさら聞けない！ローンの基礎知識一覧へ
        </BtnMain>
      </BtngroupSingle>
    </section>

    <section id="section_02" name="section_02">
      <HeadingTwo class="-border-blue _mb-sm-40 _mb-md-60"
        >教えて！みんなのローン活用術</HeadingTwo
      >
      <CardGroups class="-image-top-list">
        <CardBox router-name="sv053" class="-image-top">
          <CardHeader>
            <CardImage class="-blue"
              ><img
                src="@/assets/images/sv/sv053/thumb.jpg"
                class="img-fluid"
                alt=""
            /></CardImage>
            <h3 class="heading">“ちょっとだけ”がすごく助かる生活の工夫</h3>
          </CardHeader>
          <CardBody
            >ローンの借り入れ理由として多いのが、実は「日々の生活費」なんです！</CardBody
          >
        </CardBox>
        <CardBox router-name="sv008" class="-image-top">
          <CardHeader>
            <CardImage class="-blue"
              ><img
                src="@/assets/images/sv/sv008/thumb.jpg"
                class="img-fluid"
                alt=""
            /></CardImage>
            <h3 class="heading">急な飲み会…お給料日前だけど参加したい！</h3>
          </CardHeader>
          <CardBody
            >お誘いが多いのはうれしいけど、飲み会の回数が重なると結構な出費に…。</CardBody
          >
        </CardBox>
        <CardBox router-name="sv006" class="-image-top">
          <CardHeader>
            <CardImage class="-blue"
              ><img
                src="@/assets/images/sv/sv006/thumb.jpg"
                class="img-fluid"
                alt=""
            /></CardImage>
            <h3 class="heading">結婚＆出産…お祝いは突然やってくる?！</h3>
          </CardHeader>
          <CardBody
            >「お祝い」続きで資金不足に…せっかくのお祝いを諦める？そんなことしたくない！</CardBody
          >
        </CardBox>
      </CardGroups>
      <BtngroupSingle class="-margin-lg">
        <BtnMain class="-normal -lg" router-name="sv042"
          >教えて！みんなのローン活用術一覧へ</BtnMain
        >
      </BtngroupSingle>
    </section>

    <section id="section_03" name="section_03">
      <HeadingTwo class="-border-orange _mb-sm-40 _mb-md-60"
        >auサービスでもっとおトクに！</HeadingTwo
      >

      <CardGroups class="-image-top-list">
        <CardBox router-name="sv016" class="-image-top">
          <CardHeader>
            <CardImage class="-orange"
              ><img
                src="@/assets/images/sv/sv016/thumb.jpg"
                class="img-fluid"
                alt=""
            /></CardImage>
            <h3 class="heading">Pontaポイントでスマートな暮らしを！</h3>
          </CardHeader>
          <CardBody
            >お借り入れ方法は、au PAY
            残高にチャージがおすすめ！Pontaポイントを貯めて賢く暮らそう！</CardBody
          >
        </CardBox>
        <CardBox router-name="sv013" class="-image-top">
          <CardHeader>
            <CardImage class="-orange"
              ><img
                src="@/assets/images/sv/sv013/thumb.jpg"
                class="img-fluid"
                alt=""
            /></CardImage>
            <h3 class="heading">携帯電話の料金を見直しておトクに節約！</h3>
          </CardHeader>
          <CardBody
            >お給料日前は毎月ピンチ…節約を考えるなら、まずは「固定費」を見直してみよう。</CardBody
          >
        </CardBox>
        <CardBox router-name="sv014" class="-image-top">
          <CardHeader>
            <CardImage class="-orange"
              ><img
                src="@/assets/images/sv/sv014/thumb.jpg"
                class="img-fluid"
                alt=""
            /></CardImage>
            <h3 class="heading">
              auでんきでスマートに省エネ！Pontaポイントも貯まる！
            </h3>
          </CardHeader>
          <CardBody
            >auでんきに乗り換えれば、au スマホやau
            ひかりとセットで毎月の電気利用量に応じてPontaポイントが貯まる！アプリの活用で省エネも。</CardBody
          >
        </CardBox>
      </CardGroups>

      <BtngroupSingle class="-margin-lg">
        <BtnMain class="-normal -lg" router-name="sv044"
          >auサービスでもっとおトクに！一覧へ</BtnMain
        >
      </BtngroupSingle>
    </section>

    <CvBox class="_mb-md-120 _mb-sm-60" />
  </div>
  <!-- container -->
</template>

<script>
import { setMeta } from "@/utils/Meta";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";
import HeadingOne from "@/components/heading/HeadingOne";
import NoticeBox from "@/components/box/NoticeBox";
import IconBox from "@/components/icons/IconBox";
import HeadingTwo from "@/components/heading/HeadingTwo";
import CardGroups from "@/components/card/CardGroups";
import CardBox from "@/components/card/CardBox";
import CardHeader from "@/components/card/CardHeader";
import CardImage from "@/components/card/CardImage";
import CardBody from "@/components/card/CardBody";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";
import CvBox from "@/components/box/CvBox";
export default {
  name: "Sv003",
  components: {
    BreadcrumbGroup,
    CvBox,
    BtnMain,
    BtngroupSingle,
    CardBody,
    CardImage,
    CardHeader,
    CardBox,
    CardGroups,
    HeadingTwo,
    IconBox,
    NoticeBox,
    HeadingOne,
  },
  setup() {
    setMeta({
      title: "知っておきたい！ローンについて",
      description:
        "ローンの基礎知識や利用シーン、auサービスを活用して便利に生活する方法を分かりやすく解説します。au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,おトク",
    });
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "root",
        },
        {
          text: "知っておきたい！ローンについて",
          active: true,
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";

#section_01,
#section_02,
#section_03 {
  @include mq-up(md) {
    padding-top: 30px;
    margin-top: -30px;
  }
}

.notice-box {
  :deep(.list-box) {
    .list {
      a {
        display: flex;
        .icon-box {
          justify-content: flex-start;

          // vue2環境で当たっていないスタイルのためコメントアウト
          // .icon {
          //   margin-right: 10px;
          // }
        }
      }
    }
  }
}
</style>
